import { merchantApi } from '@/config/axios'

export interface O2oDisputeMerchantVO {
  id?: number
  disputeNo?: string
  orderId?: number
  orderNo?: string
  userId?: number
  userNickname?: string
  providerId?: number
  providerName?: string
  institutionId?: number
  institutionName?: string
  type?: string
  reason?: string
  description?: string
  evidenceUrls?: string[]
  status?: string
  respondDeadline?: string
  providerResponse?: string
  providerResponseTime?: string
  arbitratorId?: number
  arbitrateTime?: string
  verdict?: string
  verdictRemark?: string
  refundAmount?: number
  createTime?: string
}

export function getO2oMerchantDisputePage(params: {
  pageNo: number
  pageSize: number
  disputeNo?: string
  orderId?: number
  type?: string
  status?: string
}) {
  return merchantApi.get<{ list: O2oDisputeMerchantVO[]; total: number }>({
    url: '/merchant-api/o2o/dispute/page',
    params
  })
}

export function getO2oMerchantDispute(id: number) {
  return merchantApi.get<O2oDisputeMerchantVO>({
    url: '/merchant-api/o2o/dispute/get',
    params: { id }
  })
}
